import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(message) {
        this.v48_1 = message;
        this.w48_1 = null;
        this.x48_1 = null;
        this.y48_1 = null;
        this.z48_1 = null;
      }
      a49(locations) {
        // Inline function 'kotlin.apply' call
        this.w48_1 = locations;
        return this;
      }
      b49(path) {
        // Inline function 'kotlin.apply' call
        this.x48_1 = path;
        return this;
      }
      o43(extensions) {
        // Inline function 'kotlin.apply' call
        this.z48_1 = extensions;
        return this;
      }
      c49(nonStandardFields) {
        // Inline function 'kotlin.apply' call
        this.y48_1 = nonStandardFields;
        return this;
      }
      e3a() {
        return new (Error_0())(this.v48_1, this.w48_1, this.x48_1, this.z48_1, this.y48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.d49_1 = line;
        this.e49_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.d49_1 + ', column = ' + this.e49_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.f49_1 = message;
        this.g49_1 = locations;
        this.h49_1 = path;
        this.i49_1 = extensions;
        this.j49_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.f49_1 + ', locations = ' + toString(this.g49_1) + ', path=' + toString(this.h49_1) + ', extensions = ' + toString(this.i49_1) + ', nonStandardFields = ' + toString(this.j49_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Builder as Builder3gaff1pwujyid,
  Location as Location25t453jk43ktl,
};
//endregion

//# sourceMappingURL=Error.mjs.map
